import Image from "../Image/Image";
import {Link} from "react-router-dom";
import Icons from "../Icons/Icons";
import {useEffect, useState} from "react";

const Popup = ({item}) => {

    const clearHTML = (string) => {
        if (string) {
            return string.replace(/(<([^>]+)>)/gi, "").replace(/(\r\n|\n|\r)/gm, " ")
        }
    }

    const [cookie, setCookie] = useState();

    useEffect(() => {
        setCookie(localStorage.getItem(`popup`))
    })
    const onClickClose = () => {
        localStorage.setItem(`popup`, true);
        setCookie(true);
    }

    return (<>
            {
                !cookie && item &&
                <div className={"popup"}>
                    <div className={"popup__container"}>
                        <button onClick={onClickClose} type={"button"} className={"popup__close"}>x</button>
                        {item.link && <Link to={{pathname: item.link}}>
                            <Image file={item.file_src} controller={item.controller} name={clearHTML(item?.title)}/>
                        </Link>}
                        {
                            !item.link &&                             <Image file={item.file_src} controller={item.controller} name={clearHTML(item?.title)}/>

                        }
                        {!item.file_src && <div className={"popup__content"}>
                            {item.body && <div className="campaigns__item-content mb--6"
                                               dangerouslySetInnerHTML={{__html: item.body}}></div>}
                            {
                                item.link &&
                                <div className={"popup__link"}>
                                    <Link
                                        to={item.link && item.link.includes(`http`) ? {pathname: item.link} : item.link}
                                        target={item.link && item.link.includes(`http`) ? "_blank" : ""}
                                        className={"btn btn--icon"} title={clearHTML(item?.title)}>DOWIEDZ
                                        SIĘ
                                        WIĘCEJ <Icons name={"right-long"}/>
                                    </Link>
                                </div>
                            }
                        </div>}
                    </div>
                </div>
            }
        </>
    )
}

export default Popup;
